import React from "react";

import * as Icon from "react-feather";

import ActionPageHero from "../../../molecules/ActionPageHero";
import { H3, P } from "../../../atoms/Texts";

import searchWidgetHero from "../../../../assets/images/search-widget-hero-img.png";

const SearchWidgetPage = () => {
  return (
    <main className="flex flex-col w-full">
      <ActionPageHero
        className="organization-container"
        title="SSN Search Widget"
        description="Embed widgets on your website"
      />
      <section className="organization-container pb-10 flex-grow mt-10 w-4/6">
        {/* Hero */}
        <H3 color="#22202D" fontFamily="regular" font className="mt-4 mb-2 truncate">
          SSN Search Widget
        </H3>
        <P color="#7D7B96" fontSize="14px" className="mb-4">
          The widget embeds the SSN search feature onto your website. It allows you
          to use our pre-built search component, to create an interactive form that
          lets your users search for organizations offering the services they need,
          so you do not have to stress about the API integration.
        </P>
        <P color="#7D7B96" fontSize="14px" className="mb-6">
          The Social Safety Search widget is a CDN-provided, easily integrated
          component that can be added to any web page. It works similarly to the
          search feature on SSN search. The user enters the service they need or
          select from a limited list of frequently searched services. The user can
          provide a zip code or perform a general search without a location filter.
        </P>
        <img src={searchWidgetHero} alt="Hero" />

        {/* Demo */}
        <H3
          color="#22202D"
          fontFamily="regular"
          font
          className="mt-12 mb-2 truncate"
        >
          Demo
        </H3>
        <P color="#7D7B96" fontSize="14px" className="mb-6">
          To see the widget in action,{" "}
          <a
            href="https://philanthrolab.github.io/ssn-search-widget/"
            className="inline-block"
            target="_blank noreferrer noopener"
          >
            <P className="flex items-center gap-1" color="#442ED0">
              open our Demo <Icon.ExternalLink size={16} color="#442ED0" />
            </P>
          </a>
        </P>

        {/* Code Snippet */}
        <H3
          color="#22202D"
          fontFamily="regular"
          font
          className="mt-12 mb-2 truncate"
        >
          For Developers
        </H3>
        <P color="#7D7B96" fontSize="14px" className="mb-2">
          We have made it very easy to embed this widget on your webpages.
        </P>
        <P color="#7D7B96" fontSize="14px" className="mb-2">
          Get the play-by-play{" "}
          <a
            href="https://docs.socialsafety.net/use-cases/for-social-help-providers/web-app-integration#embedding-in-web-pages"
            className="inline-block"
            target="_blank noreferrer noopener"
          >
            <P className="flex items-center gap-1" color="#442ED0">
              on our docs <Icon.ExternalLink size={16} color="#442ED0" />
            </P>
          </a>
        </P>
        <P color="#7D7B96" fontSize="14px" className="mb-10">
          Use the code below to add SSN Search Widget to your webpage.
        </P>

        {/* <CopyBlock
          text={`<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta http-equiv="X-UA-Compatible" content="IE=edge" />
    <title>SSN search widget - demo</title>
    <link
      rel="stylesheet"
      href="https://ssn-search-widget.herokuapp.com/index.css"
    />
  </head>
  <body
    style="
      height: 100vh;
      display: flex;
      align-items: center;
      justify-content: center;
    "
  >
    <div
      style="height: 400px; width: auto; margin: 10px"
      id="ssn-widget"
      data-appID="AH11223"
      data-apiKey="1haiaj1h2bdja"
    ></div>
  </body>
  <script src="https://ssn-search-widget.herokuapp.com/index.js">
  </script>
</html>
          `}
          language="html"
          showLineNumbers
          wrapLines
          theme={shadesOfPurple}
          onCopy={() => toastSuccess("Copied code")}
        /> */}
      </section>
    </main>
  );
};

export default SearchWidgetPage;
